import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { Container, Card, CardBody, Col, Row, Button } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import { useHistory } from "react-router-dom"
import ReactPaginate from "react-paginate"
import { URLS } from "../../Url"
import axios from "axios"

function ViewAdvertising() {
  const history = useHistory()
  const [form, setform] = useState([])

  const [Comments, setComments] = useState([])

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token

  useEffect(() => {
    Getslider()
  }, [])

  const Sliderid = sessionStorage.getItem("PosterId")

  const [Locations, setLocations] = useState([])

  const [Category, setCategory] = useState([])

  const Getslider = () => {
    var token = datas

    const dataArray = {
      id: Sliderid,
    }

    axios
      .post(URLS.GetOnePosters, dataArray, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        setform(res.data.poster[0])
        setLocations(res?.data?.poster[0]?.location)
        setCategory(res?.data?.poster[0]?.category)
        setComments(res?.data?.comments)
      })
  }

  const [listPerPage] = useState(20)
  const [pageNumber, setPageNumber] = useState(0)

  const pagesVisited = pageNumber * listPerPage
  const lists = Comments.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(Comments.length / listPerPage)
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  const manageDelete = data => {
    const confirmBox = window.confirm("Do you really want to Delete?")
    if (confirmBox === true) {
      Delete(data)
    }
  }

  const Delete = data => {
    var token = datas

    axios
      .post(
        URLS.DeleteComment,
        { id: data._id },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            Getslider()
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Narada Media" breadcrumbItem="View Poster" />
          <Row>
            <Col>
              <Button
                onClick={() => history.goBack()}
                className="mb-3  m-1 "
                style={{ float: "right" }}
                color="primary"
              >
                <i className="far fa-arrow-alt-circle-left"></i> Back
              </Button>
            </Col>
          </Row>
          <Row className="mb-5">
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="pt-3">
                    <div className="row justify-content-center">
                      <div className="col-xl-8">
                        <div>
                          <div className="text-center">
                            <div className="mb-4">
                              <Link className="badge bg-light font-size-12">
                                <i className="bx bx-purchase-tag-alt align-middle text-muted me-1"></i>
                                Posters
                              </Link>
                            </div>
                          </div>
                          <hr />
                          <div className="text-center">
                            <Row>
                              <Col sm={4}>
                                <div>
                                  <p className="text-muted mb-2">Repoter</p>
                                  <h5 className="font-size-15">
                                    {form.reporter}
                                  </h5>
                                </div>
                              </Col>
                              <Col sm={4}>
                                <div>
                                  <p className="text-muted mb-2">Poster Id</p>
                                  <h5 className="font-size-15">
                                    {form.posterId}
                                  </h5>
                                </div>
                              </Col>
                              <Col sm={4}>
                                <div>
                                  <p className="text-muted mb-2">Date</p>
                                  <h5 className="font-size-15">
                                    {form.updatedAt?.slice(0, 10)}
                                  </h5>
                                </div>
                              </Col>
                            </Row>
                          </div>
                          <hr />
                          <div className="my-5">
                            <img
                              src={URLS.Base + form.image}
                              alt=""
                              style={{ height: "500px" }}
                              className="img-thumbnail mx-auto d-block"
                            />
                          </div>
                          <hr />
                          <Row>
                            <Col md={6}>
                              <ul className="list-inline">
                                <li className="list-inline-item mr-5">
                                  <a className="text-muted">
                                    <i
                                      className="bx bx-like align-middle text-muted me-1"
                                      style={{
                                        fontSize: "25px",
                                        color: "black",
                                      }}
                                    ></i>
                                    {form?.likes}
                                  </a>
                                </li>
                              </ul>
                            </Col>
                            <Col md={6}>
                              <div style={{ float: "right" }}>
                                <ul className="list-inline">
                                  <li className="list-inline-item mr-5">
                                    <a className="text-muted">
                                      <i
                                        className="fas fa-eye align-middle text-muted me-1"
                                        style={{
                                          fontSize: "25px",
                                          color: "black",
                                        }}
                                      ></i>
                                      {form?.views}
                                    </a>
                                  </li>
                                  <li className="list-inline-item mr-3">
                                    <a className="text-muted">
                                      <i
                                        className="bx bx-comment-dots align-middle text-muted me-1"
                                        style={{
                                          fontSize: "25px",
                                          color: "black",
                                        }}
                                      ></i>
                                      {form?.comments}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </Col>
                          </Row>
                          <hr />
                          <div className="text-center mb-3">
                            <Row>
                              <Col
                                sm={6}
                                style={{ borderRight: "1px solid black" }}
                              >
                                <div>
                                  <h5 className=" mb-2  text-primary">
                                    Location
                                  </h5>
                                  <h5 className="font-size-15 mb-2">
                                    {Locations?.map((data, key) => (
                                      <Button
                                        key={key}
                                        size="sm"
                                        className="m-1"
                                        color="primary"
                                        outline
                                      >
                                        <small className="d-flex">
                                          {data?.label}
                                        </small>
                                      </Button>
                                    ))}
                                  </h5>
                                </div>
                              </Col>
                              <Col sm={6}>
                                <div className="mt-4 mt-sm-0">
                                  <h5 className=" mb-2  text-primary">
                                    Categories
                                  </h5>
                                  <h5 className="font-size-15 mb-2">
                                    {Category?.map((data, key) => (
                                      <Button
                                        key={key}
                                        size="sm"
                                        className="m-1"
                                        color="primary"
                                        outline
                                      >
                                        <small className="d-flex">
                                          {data?.label}
                                        </small>
                                      </Button>
                                    ))}
                                  </h5>
                                </div>
                              </Col>
                            </Row>
                          </div>
                          <hr />
                          <div className="mt-5">
                            <h5 className="font-size-15">
                              <i className="bx bx-message-dots text-muted align-middle me-1" />{" "}
                              Comments:-
                            </h5>
                            {lists.length == 0 ? (
                              <>
                                <p className="text-center mt-5 mb-5"><b>No Data Found...</b></p>
                              </>
                            ) : (
                              <>
                                {lists.map((data, key) => (
                                  <div key={key}>
                                    <div className="d-flex py-3 border-bottom">
                                      <div className="flex-shrink-0 me-3">
                                        <div className="avatar-xs">
                                          <img
                                            src={URLS.Base + data.image}
                                            alt=""
                                            style={{
                                              height: "40px",
                                              width: "40px",
                                            }}
                                            className="img-fluid d-block rounded-circle"
                                          />
                                        </div>
                                      </div>
                                      <div className="flex-grow-1">
                                        <h5 className="font-size-14 mb-1">
                                          {data.name}
                                          <small className="text-muted float-end">
                                            {data.commentedAt}
                                            <br></br>
                                            <Button
                                              size="sm"
                                              color="danger"
                                              className="m-1"
                                              onClick={() => {
                                                manageDelete(data)
                                              }}
                                            >
                                              <small className="d-flex">
                                                <i className="bx bx-trash px-1"></i>
                                                Delete
                                              </small>
                                            </Button>
                                          </small>
                                        </h5>
                                        <p className="text-muted">
                                          {data.comment}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                                <div
                                  className="mt-3"
                                  style={{ float: "right" }}
                                >
                                  <ReactPaginate
                                    previousLabel={"Previous"}
                                    nextLabel={"Next"}
                                    pageCount={pageCount}
                                    onPageChange={changePage}
                                    containerClassName={"pagination"}
                                    previousLinkClassName={"previousBttn"}
                                    nextLinkClassName={"nextBttn"}
                                    disabledClassName={"disabled"}
                                    activeClassName={"active"}
                                    total={lists.length}
                                  />
                                </div>{" "}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <ToastContainer />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ViewAdvertising
